import {
  useCurrentUser,
  useLoginMutation,
  useLogoutMutation,
} from "@/api/users";

export const useAuth = () => {
  const { data: currentUser, isLoading: isCurrentUserLoading } =
    useCurrentUser();
  const { mutateAsync: login } = useLoginMutation();
  const { mutateAsync: logout } = useLogoutMutation();

  return {
    currentUser,
    isCurrentUserLoading,
    // Admins (is_staff) may curate the shared city network: hide streets and
    // mark coverage complete/incomplete.
    isAdmin: !!currentUser?.is_staff,
    login,
    logout,
  };
};
